import styled from "styled-components";

export const _MeasureSketchContainer = styled.div`
  width: 100%;
  position: relative;
  margin: 10px 0px;
  @media (min-width: 480px) {
    width: 45%;
  }

  .measure {
    margin: 0px 5px;

    @media (min-width: 480px) {
      margin: 0px 10px;
    }
  }

  @media (min-width: 900px) {
    width: 30%;
  }
`;

export const _SketchComposer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TopText = styled.span`
  display: block;
  font-size: 11px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
`;

export const LeftText = styled.span`
  font-size: 11px;
  display: inline-block;
  position: absolute;
  left: 0;
  text-align: center;
  z-index: 2;
  transform: rotate(-90deg) translate(-50%, 15px);
  transform-origin: left;
`;

export const RightText = styled.span`
  font-size: 11px;
  display: inline-block;
  position: absolute;
  right: 0;
  text-align: center;
  z-index: 2;
  transform: rotate(-270deg) translate(50%, 15px);
  transform-origin: right;
`;

export const CenterText = styled.span`
  font-size: 11px;
  display: inline-block;
  position: absolute;
  text-align: center;
  max-width: 100px;
  z-index: 2;
`;

export const BottomText = styled.span`
  display: block;
  font-size: 11px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
`;

export const Sketch = styled.img`
  width: 100%;

  &.invert {
    transform: scaleX(-1);
  }
`;

export const OverlayImage = styled.img`
  width: 100%;
  position: absolute;
`;

export const HeadLine = styled.h3`
  font-size: 18px;
  text-align: center;
  margin-bottom: 3px;

  @media (min-width: 768px) {
    font-size: 22px;
  }
`;

export const HeadlineContainer = styled.div`
  display: flex;
  border-bottom: 1px solid grey;
  align-items: flex-end;
  height: 50px;
  justify-content: center;
`;
